import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';

/**
 * Who opened the project, shown read-only on both project forms.
 *
 * Deliberately not an input: `createdById` is set once by the API from the
 * authenticated caller and is absent from the update request, so an editable
 * control here could only ever promise something the API would ignore.
 *
 * On the create form the value is the signed-in user — the person about to
 * become the creator — rather than a stored one.
 */
export function CreatedByField({ fullName }: { fullName: string }) {
  const { t } = useTranslation();
  return (
    <div>
      <Label>{t('projects.fields.createdBy')}</Label>
      <p className="text-sm text-muted-foreground">{fullName || '—'}</p>
    </div>
  );
}
